import { addHours, addYears, parse, subHours } from "date-fns";
import { getNow } from "../../utils/utils";

export interface SlotInput {
  isFlu: boolean;
  locationId: string;
  NHSSelected?: boolean;
}

// TODO: this is NOT OK, must be moved to database

const maxFluDate = parse("2026-03-31", "yyyy-MM-dd", getNow());

const isFluDisabled = (process.env.REACT_APP_FLUVAC_DISABLED === 'true'); 

export function checkIfServiceIsDisabled({ isFlu, locationId }: SlotInput) {
  if (!isFlu || !isFluDisabled) return false;
  return !checkIfIsMobileVan(locationId);
}

export function getSlotMinimumDate({ isFlu, locationId, NHSSelected}: SlotInput): Date {
  const today = getNow();
  const isMobileVan = checkIfIsMobileVan(locationId);
  // const minFluDate =  NHSSelected ? parse("10-01", "MM-dd", new Date()) : parse("09-08", "MM-dd", new Date()) ;
  const minFluDate = parse(`${new Date().getMonth() < 8 ? new Date().getFullYear() - 1 : new Date().getFullYear()}-09-08`, "yyyy-MM-dd", new Date());
  // Flu vaccines are available differently
  if (isFlu && !isMobileVan) {
    const isDuringSeason = today >= minFluDate && today < maxFluDate;
    if (!isDuringSeason) {
      const shouldBeNextYear = today > maxFluDate;
      if (shouldBeNextYear) {
        return addYears(minFluDate, 1);
      }
      const isUnder48Hours = today > subHours(minFluDate, 48);
      if (!isUnder48Hours) {
        return minFluDate;
      }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const endsUnder48Hours = today > subHours(maxFluDate, 48);
    if (endsUnder48Hours) {
      return addYears(minFluDate, 1);
    }
  }

  if (isMobileVan){
    return today;
  }

  return addHours(today, 48);
}

export function getSlotMaximumDate({
  isFlu,
  locationId,
}: SlotInput): Date | undefined {
  const today = getNow();
  const isMobileVan = checkIfIsMobileVan(locationId);

  if (isFlu && !isMobileVan) {
    const shouldBeNextYear = today > subHours(maxFluDate, 48);
    if (shouldBeNextYear) {
      return addYears(maxFluDate, 1);
    }
    return maxFluDate;
  }
}

export function checkIfIsMobileVan(locationId: string) {
  const locationIdsString = process.env.REACT_APP_VAN_LOCATIONS || "";
  if (!locationIdsString) return false;
  const locationIds = locationIdsString.split(",");
  return locationIds.includes(locationId);
}
